import { Avatar, Flex, List, Typography } from 'antd';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getRoutes } from '../../../routes/Routes';

const { Text, Title } = Typography;

const Notifications = ({ count }) => {
    const navigate = useNavigate();

    const mockNotifications = [
        {
            id: 1,
            title: 'Pending Price Approval',
            description: `You have ${count} pending prices awaiting your approval.`,
            onClick: () => navigate(getRoutes().pending_approvals.route()),
        },
    ];

    return (
        <div className="notifications-dropdown-content">
            <div className="notifications-header">
                <Flex align="center" justify="space-between">
                    <Title level={5} style={{ margin: 0 }}>
                        Notifications
                    </Title>
                </Flex>
            </div>

            <List
                className="notifications-list"
                itemLayout="horizontal"
                dataSource={mockNotifications}
                renderItem={(item) => (
                    <List.Item className={`notification-item cursor-pointer`} onClick={item.onClick}>
                        <List.Item.Meta
                            avatar={<Avatar icon={<Bell size={14} />} className="notification-icon" />}
                            title={
                                <div className="notification-title">
                                    <Text strong={item.unread}>{item.title}</Text>
                                </div>
                            }
                            description={
                                <Text type="secondary" ellipsis={{ tooltip: item.description }}>
                                    {item.description}
                                </Text>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
};

export default Notifications;
